import { FilterOptionInformation, FilterKey } from "@studyportals/search-filters";
import { FilterOptionsBase } from "./FilterOptionsBase";
import { ContinentPresenter } from "@/presenters/ContinentPresenter";

export class ContinentOptions extends FilterOptionsBase {
	public override getFilterKey(): FilterKey {
		return FilterKey.CONTINENT;
	}

	public override createOptions(): FilterOptionInformation[] {
		return ContinentPresenter.allOptions();
	}
}
